import { ERole } from '@dlap-ui/core';
import type { PortalConfig } from '@dlap-ui/shared-forms/shell/portal-shell/portal-shell';
import { DEEDS_DASHBOARD_PAGES } from './dashboard-pages.config';

export const DEEDS_PORTAL_CONFIG: PortalConfig = {
  appTitle: 'Deeds',
  logoSrc: '/deeds-logo.svg',
  searchPlaceholder: 'Search applications...',
  defaultRedirect: '/overview/profile',
  rolePermissions: [
    {
      role: ERole.ADMIN,
      permissions: [
        'applications',
        'fees',
        'users',
        'offices',
        'provinces',
        'currencies',
        'plots',
        'farms',
        'individuals-biometrics',
        'devices',
        'law-firms',
        'file-recovery',
        'file-recovery/pending-applications',
        'file-recovery/jobs',
        'tickets',
        'profile',
        'reports',
        'memberships/members',
        'roles-permissions',
        'auto-activation',
      ],
    },
    {
      role: ERole.EXAMINER,
      permissions: [
        'applications',
        'deeds/archived-plots',
        'deeds/archived-histories',
        'sanitization-audit',
        'tickets',
        'profile',
      ],
    },
    {
      role: ERole.REGISTRAR,
      permissions: [
        'applications',
        'plots',
        'plot-staging',
        'farms',
        'farm-staging',
        'deeds/missing',
        'deeds/archived-plots',
        'deeds/archived-histories',
        'sanitization-audit',
        'tickets',
        'profile',
        'reports',
      ],
    },
    {
      role: ERole.CHIEF_REGISTRAR,
      permissions: ['applications', 'sanitization-audit', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.DEPUTY_CHIEF_REGISTRAR,
      permissions: ['applications', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.LOCAL_GOV,
      permissions: ['applications', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.MINISTRY_OF_LAND,
      permissions: ['tickets', 'profile'],
    },
    {
      role: ERole.LOCAL_GOVERNMENT_TECHNICIAN,
      permissions: [
        'applications',
        'applications/drafts',
        'applications/archived',
        'wallet',
        'tickets',
        'profile',
      ],
    },
    {
      role: ERole.LOCAL_GOVERNMENT_ESTATE_OFFICER,
      permissions: ['applications', 'tickets', 'profile'],
    },
    {
      role: ERole.LOCAL_GOVERNMENT_ACCOUNTANT,
      permissions: ['applications', 'tickets', 'profile'],
    },
    {
      role: ERole.LOCAL_GOVERNMENT_DIRECTOR,
      permissions: ['applications', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.DEEDS_ACCOUNTANT,
      permissions: ['applications', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.SURVEYOR_GENERAL_ACCOUNTANT,
      permissions: ['applications', 'tickets', 'profile'],
    },
    {
      role: ERole.SURVEYOR_GENERAL_TECHNICIAN,
      permissions: ['applications', 'tickets', 'profile'],
    },
    {
      role: ERole.SURVEYOR_GENERAL,
      permissions: ['applications', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.REGISTRY,
      permissions: ['overview', 'applications', 'services', 'tickets', 'profile'],
    },
    {
      role: ERole.FINANCE_OFFICER,
      permissions: ['applications', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.MINISTER_OF_LANDS_TECHNICIAN,
      permissions: ['applications', 'applications/drafts', 'applications/archived', 'wallet', 'fees', 'tickets', 'profile'],
    },
    {
      role: ERole.MINISTER_OF_LANDS_DIRECTOR,
      permissions: ['applications', 'wallet', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.MINISTER_OF_LANDS_DIRECTOR_LEGAL,
      permissions: ['applications', 'wallet', 'tickets', 'profile'],
    },
    {
      role: ERole.DB_ADMIN,
      permissions: ['plot-staging', 'deeds/archived-plots', 'deeds/archived-histories', 'tickets', 'profile'],
    },
    {
      role: ERole.DB_ADMIN_FARMS,
      permissions: ['farm-staging', 'tickets', 'profile'],
    },
    {
      role: ERole.CHIEF_ACCOUNTANT,
      permissions: ['applications', 'tickets', 'profile', 'reports'],
    },
    {
      role: ERole.DATA_CAPTURER,
      permissions: ['plots', 'plot-staging', 'farms', 'farm-staging', 'deeds/missing', 'tickets', 'profile'],
    },
    {
      role: ERole.PRODUCT_OWNER,
      permissions: [
        'applications',
        'users',
        'plots',
        'farms',
        'devices',
        'law-firms',
        'tickets/system',
        'profile',
        'reports',
        'memberships/members',
        'roles-permissions',
        'contact-messages',
        'auto-activation',
      ],
    },
  ],
  dashboardPages: DEEDS_DASHBOARD_PAGES,
  newApplicationServiceKeys: ['deed-of-grant', 'land-tenure-deed-of-grant'],
  resolveApplicationNavigation: (service) => ({
    commands: ['/overview/apply'],
    queryParams: { service: service.value },
    successMessage: `Starting a new ${service.name} application.`,
  }),
};
